/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowLeftUp: {
  name: 'arrow-left-up';
  data: string;
} = {
  name: 'arrow-left-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.354 15.354a.5.5 0 0 0 0-.708L2.207 1.5H12a.5.5 0 0 0 0-1H1a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 1 0V2.207l13.146 13.147a.5.5 0 0 0 .707 0Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
